import React from 'react';

import logo from '../assets/image/logo.png';

const defaultMenuItems = [
  { href: '#home', label: 'Home' },
  { href: '#tours', label: 'Tours' },
  { href: '#similar-tours', label: 'Similar Tours' },
  { href: '#inquire-now', label: 'Inquire Now' },
  { href: '#contacts', label: 'Contacts' },
];

const Sidebar = ({ isOpen, onClose, logoUrl = logo, brandName = 'TripRex', menuItems = defaultMenuItems }) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="sidebar-overlay" onClick={onClose}></div>
      <div className="sidebar mobile-nav">
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <img src={logoUrl} alt={brandName} className="brand-logo" />
          </div>
          <button className="close-btn" onClick={onClose} aria-label="Close menu">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>

        <nav className="mobile-menu">
          <ul className="mobile-menu-list">
            {menuItems.map((item) => (
              <li key={item.label} className="mobile-item">
                <a className="mobile-link" href={item.href} onClick={onClose}>{item.label}</a>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </>
  );
};

export default Sidebar;
